<template>
  <v-expand-transition>
    <div v-if="shouldDisplayErrors">

      <div class="errors-vincols multi-info-message" v-if="getBet.errors_multi_info && getBet.errors_multi_info.length > 0 && getBet.odds.length > 0">
        <v-alert dense text type="error" v-for="(error, index) in getBet.errors_multi_info" :key="'error_info_multi_'+index" style="padding: 5px;">
          {{ $t(error.message) }}
        </v-alert>
      </div>

      <div class="errors-vincols" v-if="smartErrors.length > 0 && getBet.odds.length > 0">
        <v-alert dense text type="warning" v-for="(error, index) in smartErrors" :key="'smart_'+index" style="padding: 5px; border-color: orange;">
          <strong>{{ $t('cart.error.attention') || 'Attenzione:' }}</strong>
          {{ $t(error.messageKey, error.messageParams) }}
        </v-alert>
      </div>

      <div class="errors-vincols" v-if="legacyErrors.length > 0 && getBet.odds.length > 0">
        <v-alert dense text type="error" v-for="(error, index) in legacyErrors" :key="'error_'+index" style="padding: 5px;">
          {{ (error.message && error.message.includes('#')) ? getErrorDesc(error.message) : $t(error.message) }}
          <span v-if="error.message == 'minimumAmountNotRespected' || error.message == 'maximumAmountNotRespected'">
            {{ getSettings.currencySymbol }} {{error.value}}
          </span>
        </v-alert>
      </div>

    </div>
  </v-expand-transition>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'Errors',
    data: () => ({}),
    computed: {
      ...mapGetters({
        'getBet': 'cart/getBet',
        'getSettings': 'cart/getSettings',
      }),

      smartErrors() {
        if (!this.getBet.errors) return [];
        return this.getBet.errors.filter(e => e.messageKey);
      },

      legacyErrors() {
        if (!this.getBet.errors) return [];
        return this.getBet.errors.filter(e => !e.messageKey);
      },

      shouldDisplayErrors() {
        const hasMultiInfo = this.getBet.errors_multi_info && this.getBet.errors_multi_info.length > 0;
        const hasAnyError = this.getBet.errors && this.getBet.errors.length > 0;

        return (hasMultiInfo || hasAnyError) && this.getBet.odds && this.getBet.odds.length > 0;
      }
    },
    methods: {
      ...mapActions({}),
      getErrorDesc(message){
        var split = message.split('#');
        return split[0] + ' ' + this.$t(split[1]);
      }
    }
  };
</script>